export default {
  remove: 'Вы хотите удалить {msg}',
  toggle: 'Вы хотите переключить {msg}',
  update: 'Вы хотите обновить {msg}',
  stop: 'Вы хотите остановить {msg}',
  restart: 'Вы хотите перезапустить {msg}',
  reset: 'Вы хотите сбросить настройки {msg}',
  saveBeforeNextPage: 'Сохранить изменения перед переходом на следущую страницу?'
}
